import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LongRunningRequestService } from '../services/long-running-request.service';
import { IS_INSIGHTS_REQUEST, SKIP_LONG_RUNNING_NOTICE } from '../tokens/http-context.tokens';

@Injectable()
export class LongRunningRequestInterceptor implements HttpInterceptor {
    constructor(private readonly _longRunningRequestService: LongRunningRequestService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!this._shouldTrack(req)) {
            return next.handle(req);
        }

        const stop = this._longRunningRequestService.trackRequest(req.context.get(IS_INSIGHTS_REQUEST));
        return next.handle(req).pipe(finalize(() => stop()));
    }

    private _shouldTrack(req: HttpRequest<any>): boolean {
        return req.url.startsWith(environment.baseURL) && !req.context.get(SKIP_LONG_RUNNING_NOTICE);
    }
}
